import React, { Suspense } from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAuthenticatedEntry } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';

const AuthenticatedHomeRedirect = () => {
	const me = useSelector((state) => state.auth.me);
	return <Navigate replace to={getAuthenticatedEntry(me)} />;
};

// Consent OAuth (conectar Claude vía MCP). Lazy: sólo se carga cuando un
// cliente MCP abre el browser para autorizar.
const OAuthConsentView = React.lazy(() => import('views/oauth-consent'));

const Routes = () => {

	return (
		<RouterRoutes>
			{/*
				/oauth/consent va suelta, fuera de ProtectedRoute y PublicRoute:
				Protected perdería los query params OAuth en el redirect de login y
				Public rebotaría a los usuarios ya logueados. La página maneja el
				auth por su cuenta (login incluido).
			*/}
			<Route
				path="/oauth/consent"
				element={
					<Suspense fallback={null}>
						<OAuthConsentView />
					</Suspense>
				}
			/>
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<AuthenticatedHomeRedirect />} />
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/ >
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes